import CompanyLogo from "../../../components/CompanyLogo/CompanyLogo";
import "./CompaniesCarousel.css";
import "./Companies.css";
import {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {filterLandingCompanies, getCompaniesCarouselDuration} from "../../../utils/landingCompanies";

const Companies = ({activeCompanies, variant}) => {
    const filteredCompanies = filterLandingCompanies(activeCompanies);
    const [loop, setLoop] = useState(false);
    const carouselRef = useRef(null);
    const carouselContainerRef = useRef(null);
    const isHero = variant === "hero";

    const updateCarousel = () => {
        const carousel = carouselRef.current;
        const carouselContainer = carouselContainerRef.current;
        if (!carousel || !carouselContainer) {
            return;
        }

        const slides = carousel.querySelectorAll(".CompaniesCarousel__slide");
        const slidesArr = Array.from(slides);
        const totalWidth = slidesArr.reduce((sum, slide) => sum + slide.offsetWidth, 0);
        const carouselContainerWidth = carouselContainer.offsetWidth;

        setLoop(totalWidth > carouselContainerWidth);
    };

    useEffect(() => {
        updateCarousel();
        window.addEventListener("resize", updateCarousel);
        return () => {
            window.removeEventListener("resize", updateCarousel);
        };
    }, [filteredCompanies]);

    if (filteredCompanies.length === 0) {
        return null;
    }

    return (
        <div
            className={`Companies__container${isHero ? " Companies__container--hero" : ""}`}
            ref={carouselContainerRef}
        >
            <div
                className={`CompaniesCarousel ${loop ? "--animated" : "--centered"}${isHero ? " CompaniesCarousel--hero" : ""}`}
                ref={carouselRef}
                style={{
                    '--CC-animation-duration': getCompaniesCarouselDuration(filteredCompanies.length),
                    '--CC-slides': filteredCompanies.length
                }}
            >
                {filteredCompanies.map((company, idx) => (
                    <div
                        className={`CompaniesCarousel__slide ${loop ? "--animated" : "--centered"}`}
                        key={`${company}-${idx}`}
                        style={{
                            animationDelay: `calc(var(--CC-animation-duration) / ${filteredCompanies.length} * (${filteredCompanies.length} - ${idx}) * -1)`,
                        }}
                    >
                        <div className="CompaniesCarousel__logo">
                            <CompanyLogo company={company}/>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

Companies.propTypes = {
    activeCompanies: PropTypes.arrayOf(PropTypes.string),
    variant: PropTypes.oneOf(["hero"]),
};

export default Companies;
